"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.buildAvailableOptions = buildAvailableOptions;
exports.findFieldUpdate = findFieldUpdate;
exports.getFilterBarActionWrapperColumnCss = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
require("core-js/modules/es6.array.filter.js");
require("core-js/modules/es6.string.includes.js");
require("core-js/modules/es7.array.includes.js");
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _filter = require("@nucleo/filter");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _templateObject, _templateObject2;
function cov_11cyncpti5() {
  var path = "/codebuild/output/src4001455011/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/FilterBar/lib/helper.js";
  var hash = "9f2377d82ba9ba2984c7ba7fcada869c2d389480";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src4001455011/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/FilterBar/lib/helper.js",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 25,
          column: 3
        }
      },
      "1": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 22
        }
      },
      "2": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 36,
          column: 3
        }
      },
      "3": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 26
        }
      },
      "4": {
        start: {
          line: 38,
          column: 26
        },
        end: {
          line: 42,
          column: 3
        }
      },
      "5": {
        start: {
          line: 43,
          column: 24
        },
        end: {
          line: 43,
          column: 53
        }
      },
      "6": {
        start: {
          line: 45,
          column: 32
        },
        end: {
          line: 51,
          column: 3
        }
      },
      "7": {
        start: {
          line: 46,
          column: 16
        },
        end: {
          line: 46,
          column: 17
        }
      },
      "8": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 49,
          column: 7
        }
      },
      "9": {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 40
        }
      },
      "10": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 50,
          column: 17
        }
      },
      "11": {
        start: {
          line: 53,
          column: 38
        },
        end: {
          line: 54,
          column: 91
        }
      },
      "12": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 91
        }
      },
      "13": {
        start: {
          line: 56,
          column: 28
        },
        end: {
          line: 65,
          column: 3
        }
      },
      "14": {
        start: {
          line: 57,
          column: 19
        },
        end: {
          line: 57,
          column: 21
        }
      },
      "15": {
        start: {
          line: 58,
          column: 23
        },
        end: {
          line: 58,
          column: 53
        }
      },
      "16": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 63,
          column: 7
        }
      },
      "17": {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 62,
          column: 7
        }
      },
      "18": {
        start: {
          line: 61,
          column: 8
        },
        end: {
          line: 61,
          column: 34
        }
      },
      "19": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 18
        }
      },
      "20": {
        start: {
          line: 71,
          column: 32
        },
        end: {
          line: 79,
          column: 3
        }
      },
      "21": {
        start: {
          line: 72,
          column: 27
        },
        end: {
          line: 72,
          column: 45
        }
      },
      "22": {
        start: {
          line: 73,
          column: 19
        },
        end: {
          line: 73,
          column: 45
        }
      },
      "23": {
        start: {
          line: 74,
          column: 27
        },
        end: {
          line: 74,
          column: 75
        }
      },
      "24": {
        start: {
          line: 74,
          column: 50
        },
        end: {
          line: 74,
          column: 74
        }
      },
      "25": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 78,
          column: 6
        }
      },
      "26": {
        start: {
          line: 81,
          column: 24
        },
        end: {
          line: 81,
          column: 67
        }
      },
      "27": {
        start: {
          line: 82,
          column: 22
        },
        end: {
          line: 82,
          column: 62
        }
      },
      "28": {
        start: {
          line: 83,
          column: 22
        },
        end: {
          line: 83,
          column: 62
        }
      },
      "29": {
        start: {
          line: 85,
          column: 2
        },
        end: {
          line: 151,
          column: 5
        }
      },
      "30": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 95,
          column: 5
        }
      },
      "31": {
        start: {
          line: 88,
          column: 6
        },
        end: {
          line: 91,
          column: 7
        }
      },
      "32": {
        start: {
          line: 89,
          column: 8
        },
        end: {
          line: 89,
          column: 54
        }
      },
      "33": {
        start: {
          line: 90,
          column: 8
        },
        end: {
          line: 90,
          column: 58
        }
      },
      "34": {
        start: {
          line: 92,
          column: 6
        },
        end: {
          line: 94,
          column: 7
        }
      },
      "35": {
        start: {
          line: 93,
          column: 8
        },
        end: {
          line: 93,
          column: 50
        }
      },
      "36": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 124,
          column: 5
        }
      },
      "37": {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 113,
          column: 7
        }
      },
      "38": {
        start: {
          line: 112,
          column: 8
        },
        end: {
          line: 112,
          column: 50
        }
      },
      "39": {
        start: {
          line: 115,
          column: 6
        },
        end: {
          line: 117,
          column: 7
        }
      },
      "40": {
        start: {
          line: 116,
          column: 8
        },
        end: {
          line: 116,
          column: 54
        }
      },
      "41": {
        start: {
          line: 118,
          column: 6
        },
        end: {
          line: 123,
          column: 7
        }
      },
      "42": {
        start: {
          line: 122,
          column: 8
        },
        end: {
          line: 122,
          column: 58
        }
      },
      "43": {
        start: {
          line: 127,
          column: 4
        },
        end: {
          line: 150,
          column: 5
        }
      },
      "44": {
        start: {
          line: 128,
          column: 6
        },
        end: {
          line: 149,
          column: 7
        }
      },
      "45": {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 140,
          column: 9
        }
      },
      "46": {
        start: {
          line: 139,
          column: 10
        },
        end: {
          line: 139,
          column: 52
        }
      },
      "47": {
        start: {
          line: 142,
          column: 8
        },
        end: {
          line: 148,
          column: 9
        }
      },
      "48": {
        start: {
          line: 147,
          column: 10
        },
        end: {
          line: 147,
          column: 52
        }
      },
      "49": {
        start: {
          line: 154,
          column: 2
        },
        end: {
          line: 159,
          column: 99
        }
      },
      "50": {
        start: {
          line: 159,
          column: 56
        },
        end: {
          line: 159,
          column: 97
        }
      },
      "51": {
        start: {
          line: 161,
          column: 2
        },
        end: {
          line: 163,
          column: 81
        }
      },
      "52": {
        start: {
          line: 163,
          column: 41
        },
        end: {
          line: 163,
          column: 79
        }
      },
      "53": {
        start: {
          line: 165,
          column: 2
        },
        end: {
          line: 167,
          column: 81
        }
      },
      "54": {
        start: {
          line: 167,
          column: 41
        },
        end: {
          line: 167,
          column: 79
        }
      },
      "55": {
        start: {
          line: 169,
          column: 2
        },
        end: {
          line: 169,
          column: 23
        }
      },
      "56": {
        start: {
          line: 173,
          column: 28
        },
        end: {
          line: 173,
          column: 30
        }
      },
      "57": {
        start: {
          line: 174,
          column: 2
        },
        end: {
          line: 178,
          column: 5
        }
      },
      "58": {
        start: {
          line: 175,
          column: 4
        },
        end: {
          line: 177,
          column: 5
        }
      },
      "59": {
        start: {
          line: 176,
          column: 6
        },
        end: {
          line: 176,
          column: 34
        }
      },
      "60": {
        start: {
          line: 179,
          column: 2
        },
        end: {
          line: 179,
          column: 27
        }
      },
      "61": {
        start: {
          line: 182,
          column: 50
        },
        end: {
          line: 194,
          column: 3
        }
      },
      "62": {
        start: {
          line: 183,
          column: 2
        },
        end: {
          line: 194,
          column: 3
        }
      },
      "63": {
        start: {
          line: 185,
          column: 27
        },
        end: {
          line: 185,
          column: 82
        }
      },
      "64": {
        start: {
          line: 186,
          column: 24
        },
        end: {
          line: 186,
          column: 41
        }
      },
      "65": {
        start: {
          line: 187,
          column: 24
        },
        end: {
          line: 187,
          column: 48
        }
      },
      "66": {
        start: {
          line: 188,
          column: 23
        },
        end: {
          line: 188,
          column: 45
        }
      },
      "67": {
        start: {
          line: 189,
          column: 22
        },
        end: {
          line: 189,
          column: 35
        }
      },
      "68": {
        start: {
          line: 190,
          column: 6
        },
        end: {
          line: 192,
          column: 8
        }
      }
    },
    fnMap: {
      "0": {
        name: "buildAvailableOptions",
        decl: {
          start: {
            line: 8,
            column: 16
          },
          end: {
            line: 8,
            column: 37
          }
        },
        loc: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 170,
            column: 1
          }
        },
        line: 13
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 45,
            column: 32
          },
          end: {
            line: 45,
            column: 33
          }
        },
        loc: {
          start: {
            line: 45,
            column: 42
          },
          end: {
            line: 51,
            column: 3
          }
        },
        line: 45
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 47,
            column: 19
          },
          end: {
            line: 47,
            column: 20
          }
        },
        loc: {
          start: {
            line: 47,
            column: 28
          },
          end: {
            line: 49,
            column: 5
          }
        },
        line: 47
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 53,
            column: 38
          },
          end: {
            line: 53,
            column: 39
          }
        },
        loc: {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 91
          }
        },
        line: 54
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 56,
            column: 28
          },
          end: {
            line: 56,
            column: 29
          }
        },
        loc: {
          start: {
            line: 56,
            column: 39
          },
          end: {
            line: 65,
            column: 3
          }
        },
        line: 56
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 59,
            column: 33
          },
          end: {
            line: 59,
            column: 34
          }
        },
        loc: {
          start: {
            line: 59,
            column: 40
          },
          end: {
            line: 63,
            column: 5
          }
        },
        line: 59
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 71,
            column: 32
          },
          end: {
            line: 71,
            column: 33
          }
        },
        loc: {
          start: {
            line: 71,
            column: 56
          },
          end: {
            line: 79,
            column: 3
          }
        },
        line: 71
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 74,
            column: 41
          },
          end: {
            line: 74,
            column: 42
          }
        },
        loc: {
          start: {
            line: 74,
            column: 50
          },
          end: {
            line: 74,
            column: 74
          }
        },
        line: 74
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 85,
            column: 44
          },
          end: {
            line: 85,
            column: 45
          }
        },
        loc: {
          start: {
            line: 85,
            column: 63
          },
          end: {
            line: 151,
            column: 3
          }
        },
        line: 85
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 159,
            column: 47
          },
          end: {
            line: 159,
            column: 48
          }
        },
        loc: {
          start: {
            line: 159,
            column: 56
          },
          end: {
            line: 159,
            column: 97
          }
        },
        line: 159
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 163,
            column: 33
          },
          end: {
            line: 163,
            column: 34
          }
        },
        loc: {
          start: {
            line: 163,
            column: 41
          },
          end: {
            line: 163,
            column: 79
          }
        },
        line: 163
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 167,
            column: 33
          },
          end: {
            line: 167,
            column: 34
          }
        },
        loc: {
          start: {
            line: 167,
            column: 41
          },
          end: {
            line: 167,
            column: 79
          }
        },
        line: 167
      },
      "12": {
        name: "findFieldUpdate",
        decl: {
          start: {
            line: 172,
            column: 16
          },
          end: {
            line: 172,
            column: 31
          }
        },
        loc: {
          start: {
            line: 172,
            column: 58
          },
          end: {
            line: 180,
            column: 1
          }
        },
        line: 172
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 174,
            column: 35
          },
          end: {
            line: 174,
            column: 36
          }
        },
        loc: {
          start: {
            line: 174,
            column: 42
          },
          end: {
            line: 178,
            column: 3
          }
        },
        line: 174
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 182,
            column: 50
          },
          end: {
            line: 182,
            column: 51
          }
        },
        loc: {
          start: {
            line: 183,
            column: 2
          },
          end: {
            line: 194,
            column: 3
          }
        },
        line: 183
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 184,
            column: 6
          },
          end: {
            line: 184,
            column: 7
          }
        },
        loc: {
          start: {
            line: 184,
            column: 24
          },
          end: {
            line: 193,
            column: 5
          }
        },
        line: 184
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 26
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 12,
            column: 24
          },
          end: {
            line: 12,
            column: 26
          }
        }],
        line: 12
      },
      "1": {
        loc: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 14
      },
      "2": {
        loc: {
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 22,
            column: 19
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 16,
            column: 36
          }
        }, {
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 18,
            column: 38
          }
        }, {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 19,
            column: 20
          }
        }, {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 20,
            column: 87
          }
        }, {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 22,
            column: 19
          }
        }],
        line: 16
      },
      "3": {
        loc: {
          start: {
            line: 20,
            column: 6
          },
          end: {
            line: 20,
            column: 86
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 6
          },
          end: {
            line: 20,
            column: 32
          }
        }, {
          start: {
            line: 20,
            column: 36
          },
          end: {
            line: 20,
            column: 59
          }
        }, {
          start: {
            line: 20,
            column: 63
          },
          end: {
            line: 20,
            column: 86
          }
        }],
        line: 20
      },
      "4": {
        loc: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 36,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 36,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 29
      },
      "5": {
        loc: {
          start: {
            line: 30,
            column: 5
          },
          end: {
            line: 30,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 5
          },
          end: {
            line: 30,
            column: 31
          }
        }, {
          start: {
            line: 30,
            column: 35
          },
          end: {
            line: 30,
            column: 68
          }
        }],
        line: 30
      },
      "6": {
        loc: {
          start: {
            line: 31,
            column: 7
          },
          end: {
            line: 31,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 7
          },
          end: {
            line: 31,
            column: 30
          }
        }, {
          start: {
            line: 31,
            column: 34
          },
          end: {
            line: 31,
            column: 64
          }
        }],
        line: 31
      },
      "7": {
        loc: {
          start: {
            line: 32,
            column: 7
          },
          end: {
            line: 32,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 32,
            column: 7
          },
          end: {
            line: 32,
            column: 30
          }
        }, {
          start: {
            line: 32,
            column: 34
          },
          end: {
            line: 32,
            column: 64
          }
        }],
        line: 32
      },
      "8": {
        loc: {
          start: {
            line: 48,
            column: 15
          },
          end: {
            line: 48,
            column: 39
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 48,
            column: 23
          },
          end: {
            line: 48,
            column: 35
          }
        }, {
          start: {
            line: 48,
            column: 38
          },
          end: {
            line: 48,
            column: 39
          }
        }],
        line: 48
      },
      "9": {
        loc: {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 18
          }
        }, {
          start: {
            line: 54,
            column: 22
          },
          end: {
            line: 54,
            column: 47
          }
        }, {
          start: {
            line: 54,
            column: 51
          },
          end: {
            line: 54,
            column: 91
          }
        }],
        line: 54
      },
      "10": {
        loc: {
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 62,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 62,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 60
      },
      "11": {
        loc: {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 77,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 76,
            column: 45
          }
        }, {
          start: {
            line: 77,
            column: 6
          },
          end: {
            line: 77,
            column: 65
          }
        }],
        line: 76
      },
      "12": {
        loc: {
          start: {
            line: 81,
            column: 34
          },
          end: {
            line: 81,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 81,
            column: 34
          },
          end: {
            line: 81,
            column: 60
          }
        }, {
          start: {
            line: 81,
            column: 64
          },
          end: {
            line: 81,
            column: 66
          }
        }],
        line: 81
      },
      "13": {
        loc: {
          start: {
            line: 82,
            column: 32
          },
          end: {
            line: 82,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 82,
            column: 32
          },
          end: {
            line: 82,
            column: 55
          }
        }, {
          start: {
            line: 82,
            column: 59
          },
          end: {
            line: 82,
            column: 61
          }
        }],
        line: 82
      },
      "14": {
        loc: {
          start: {
            line: 83,
            column: 32
          },
          end: {
            line: 83,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 83,
            column: 32
          },
          end: {
            line: 83,
            column: 55
          }
        }, {
          start: {
            line: 83,
            column: 59
          },
          end: {
            line: 83,
            column: 61
          }
        }],
        line: 83
      },
      "15": {
        loc: {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 87
      },
      "16": {
        loc: {
          start: {
            line: 87,
            column: 8
          },
          end: {
            line: 87,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 87,
            column: 8
          },
          end: {
            line: 87,
            column: 34
          }
        }, {
          start: {
            line: 87,
            column: 38
          },
          end: {
            line: 87,
            column: 89
          }
        }],
        line: 87
      },
      "17": {
        loc: {
          start: {
            line: 88,
            column: 6
          },
          end: {
            line: 91,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 88,
            column: 6
          },
          end: {
            line: 91,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 88
      },
      "18": {
        loc: {
          start: {
            line: 88,
            column: 10
          },
          end: {
            line: 88,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 88,
            column: 10
          },
          end: {
            line: 88,
            column: 34
          }
        }, {
          start: {
            line: 88,
            column: 38
          },
          end: {
            line: 88,
            column: 66
          }
        }],
        line: 88
      },
      "19": {
        loc: {
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 94,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 94,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 92
      },
      "20": {
        loc: {
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 124,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 124,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 98
      },
      "21": {
        loc: {
          start: {
            line: 99,
            column: 6
          },
          end: {
            line: 101,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 99,
            column: 6
          },
          end: {
            line: 99,
            column: 29
          }
        }, {
          start: {
            line: 100,
            column: 6
          },
          end: {
            line: 100,
            column: 26
          }
        }, {
          start: {
            line: 101,
            column: 6
          },
          end: {
            line: 101,
            column: 69
          }
        }],
        line: 99
      },
      "22": {
        loc: {
          start: {
            line: 104,
            column: 6
          },
          end: {
            line: 113,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 104,
            column: 6
          },
          end: {
            line: 113,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 104
      },
      "23": {
        loc: {
          start: {
            line: 105,
            column: 8
          },
          end: {
            line: 110,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 105,
            column: 8
          },
          end: {
            line: 105,
            column: 32
          }
        }, {
          start: {
            line: 106,
            column: 9
          },
          end: {
            line: 106,
            column: 32
          }
        }, {
          start: {
            line: 107,
            column: 10
          },
          end: {
            line: 107,
            column: 34
          }
        }, {
          start: {
            line: 108,
            column: 10
          },
          end: {
            line: 108,
            column: 38
          }
        }, {
          start: {
            line: 109,
            column: 11
          },
          end: {
            line: 109,
            column: 78
          }
        }, {
          start: {
            line: 110,
            column: 12
          },
          end: {
            line: 110,
            column: 83
          }
        }],
        line: 105
      },
      "24": {
        loc: {
          start: {
            line: 115,
            column: 6
          },
          end: {
            line: 117,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 6
          },
          end: {
            line: 117,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 115
      },
      "25": {
        loc: {
          start: {
            line: 115,
            column: 10
          },
          end: {
            line: 115,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 115,
            column: 10
          },
          end: {
            line: 115,
            column: 34
          }
        }, {
          start: {
            line: 115,
            column: 38
          },
          end: {
            line: 115,
            column: 93
          }
        }],
        line: 115
      },
      "26": {
        loc: {
          start: {
            line: 118,
            column: 6
          },
          end: {
            line: 123,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 118,
            column: 6
          },
          end: {
            line: 123,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 118
      },
      "27": {
        loc: {
          start: {
            line: 119,
            column: 8
          },
          end: {
            line: 120,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 119,
            column: 8
          },
          end: {
            line: 119,
            column: 36
          }
        }, {
          start: {
            line: 120,
            column: 8
          },
          end: {
            line: 120,
            column: 67
          }
        }],
        line: 119
      },
      "28": {
        loc: {
          start: {
            line: 127,
            column: 4
          },
          end: {
            line: 150,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 127,
            column: 4
          },
          end: {
            line: 150,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 127
      },
      "29": {
        loc: {
          start: {
            line: 127,
            column: 8
          },
          end: {
            line: 127,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 127,
            column: 8
          },
          end: {
            line: 127,
            column: 31
          }
        }, {
          start: {
            line: 127,
            column: 35
          },
          end: {
            line: 127,
            column: 59
          }
        }, {
          start: {
            line: 127,
            column: 63
          },
          end: {
            line: 127,
            column: 91
          }
        }],
        line: 127
      },
      "30": {
        loc: {
          start: {
            line: 128,
            column: 6
          },
          end: {
            line: 149,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 128,
            column: 6
          },
          end: {
            line: 149,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 128
      },
      "31": {
        loc: {
          start: {
            line: 129,
            column: 8
          },
          end: {
            line: 130,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 129,
            column: 8
          },
          end: {
            line: 129,
            column: 75
          }
        }, {
          start: {
            line: 130,
            column: 8
          },
          end: {
            line: 130,
            column: 79
          }
        }],
        line: 129
      },
      "32": {
        loc: {
          start: {
            line: 133,
            column: 8
          },
          end: {
            line: 140,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 133,
            column: 8
          },
          end: {
            line: 140,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 133
      },
      "33": {
        loc: {
          start: {
            line: 134,
            column: 10
          },
          end: {
            line: 137,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 134,
            column: 10
          },
          end: {
            line: 134,
            column: 34
          }
        }, {
          start: {
            line: 135,
            column: 11
          },
          end: {
            line: 135,
            column: 34
          }
        }, {
          start: {
            line: 136,
            column: 12
          },
          end: {
            line: 136,
            column: 32
          }
        }, {
          start: {
            line: 137,
            column: 12
          },
          end: {
            line: 137,
            column: 75
          }
        }],
        line: 134
      },
      "34": {
        loc: {
          start: {
            line: 142,
            column: 8
          },
          end: {
            line: 148,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 142,
            column: 8
          },
          end: {
            line: 148,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 142
      },
      "35": {
        loc: {
          start: {
            line: 143,
            column: 10
          },
          end: {
            line: 145,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 143,
            column: 10
          },
          end: {
            line: 143,
            column: 30
          }
        }, {
          start: {
            line: 144,
            column: 10
          },
          end: {
            line: 144,
            column: 33
          }
        }, {
          start: {
            line: 145,
            column: 10
          },
          end: {
            line: 145,
            column: 61
          }
        }],
        line: 143
      },
      "36": {
        loc: {
          start: {
            line: 154,
            column: 41
          },
          end: {
            line: 159,
            column: 98
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 158,
            column: 6
          },
          end: {
            line: 158,
            column: 43
          }
        }, {
          start: {
            line: 159,
            column: 6
          },
          end: {
            line: 159,
            column: 98
          }
        }],
        line: 154
      },
      "37": {
        loc: {
          start: {
            line: 161,
            column: 27
          },
          end: {
            line: 163,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 162,
            column: 6
          },
          end: {
            line: 162,
            column: 29
          }
        }, {
          start: {
            line: 163,
            column: 6
          },
          end: {
            line: 163,
            column: 80
          }
        }],
        line: 161
      },
      "38": {
        loc: {
          start: {
            line: 165,
            column: 27
          },
          end: {
            line: 167,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 166,
            column: 6
          },
          end: {
            line: 166,
            column: 29
          }
        }, {
          start: {
            line: 167,
            column: 6
          },
          end: {
            line: 167,
            column: 80
          }
        }],
        line: 165
      },
      "39": {
        loc: {
          start: {
            line: 175,
            column: 4
          },
          end: {
            line: 177,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 175,
            column: 4
          },
          end: {
            line: 177,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 175
      },
      "40": {
        loc: {
          start: {
            line: 182,
            column: 51
          },
          end: {
            line: 182,
            column: 59
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 182,
            column: 58
          },
          end: {
            line: 182,
            column: 59
          }
        }],
        line: 182
      },
      "41": {
        loc: {
          start: {
            line: 188,
            column: 23
          },
          end: {
            line: 188,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 188,
            column: 23
          },
          end: {
            line: 188,
            column: 32
          }
        }, {
          start: {
            line: 188,
            column: 36
          },
          end: {
            line: 188,
            column: 45
          }
        }],
        line: 188
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0, 0, 0, 0],
      "3": [0, 0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0, 0],
      "22": [0, 0],
      "23": [0, 0, 0, 0, 0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0, 0, 0],
      "34": [0, 0],
      "35": [0, 0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0],
      "41": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9f2377d82ba9ba2984c7ba7fcada869c2d389480"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_11cyncpti5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_11cyncpti5();
/* When a filter is selected, it will check other filter to remove redundant options (which return empty result)
* Currently, just apply for 3 filters which hospitality has data: TEAM, SITE, MATCH NAME
*/
function buildAvailableOptions(allOptions, currentOptions, selectedOptions) {
  var filterFieldsChanges = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (cov_11cyncpti5().b[0][0]++, []);
  cov_11cyncpti5().f[0]++;
  cov_11cyncpti5().s[0]++;
  if (
  // If do not have any filter is changed
  (cov_11cyncpti5().b[2][0]++, filterFieldsChanges.length === 0) || (cov_11cyncpti5().b[2][1]++,
  // IF do not have any option is selected
  !allOptions.hospitalitySessionData) || (cov_11cyncpti5().b[2][2]++, !selectedOptions) || (cov_11cyncpti5().b[2][3]++, !((cov_11cyncpti5().b[3][0]++, selectedOptions.matchNames) || (cov_11cyncpti5().b[3][1]++, selectedOptions.siteIds) || (cov_11cyncpti5().b[3][2]++, selectedOptions.teamIds))) || (cov_11cyncpti5().b[2][4]++,
  // IF current available option is not initialized
  !currentOptions)) {
    cov_11cyncpti5().b[1][0]++;
    cov_11cyncpti5().s[1]++;
    return allOptions; // all options from begin
  } else {
    cov_11cyncpti5().b[1][1]++;
  }

  // Check if there is a first selection (only 1 selected option)
  // => not removing the rest of options in that filter
  cov_11cyncpti5().s[2]++;
  if (((cov_11cyncpti5().b[5][0]++, selectedOptions.matchNames) && (cov_11cyncpti5().b[5][1]++, selectedOptions.matchNames.length)) + ((cov_11cyncpti5().b[6][0]++, selectedOptions.siteIds) && (cov_11cyncpti5().b[6][1]++, selectedOptions.siteIds.length)) + ((cov_11cyncpti5().b[7][0]++, selectedOptions.teamIds) && (cov_11cyncpti5().b[7][1]++, selectedOptions.teamIds.length)) === 1) {
    cov_11cyncpti5().b[4][0]++;
    cov_11cyncpti5().s[3]++;
    return currentOptions;
  } else {
    cov_11cyncpti5().b[4][1]++;
  }
  var filterFieldName = (cov_11cyncpti5().s[4]++, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, _filter.FilterField.SITE, "".concat(_filter.FilterField.SITE, "Ids")), _filter.FilterField.TEAM, "".concat(_filter.FilterField.TEAM, "Ids")), _filter.FilterField.MATCH_NAME, "".concat(_filter.FilterField.MATCH_NAME, "s")));
  var resultOptions = (cov_11cyncpti5().s[5]++, (0, _assign.default)({}, allOptions));
  cov_11cyncpti5().s[6]++;
  var countTotalArrayLength = function countTotalArrayLength(arrays) {
    cov_11cyncpti5().f[1]++;
    var count = (cov_11cyncpti5().s[7]++, 0);
    cov_11cyncpti5().s[8]++;
    arrays.forEach(function (array) {
      cov_11cyncpti5().f[2]++;
      cov_11cyncpti5().s[9]++;
      count += array ? (cov_11cyncpti5().b[8][0]++, array.length) : (cov_11cyncpti5().b[8][1]++, 0);
    });
    cov_11cyncpti5().s[10]++;
    return count;
  };
  // Check if filedNeedCheck is the only field that is currently selected
  cov_11cyncpti5().s[11]++;
  var isJustOnlyThisFieldSelected = function isJustOnlyThisFieldSelected(fieldNeedCheck, otherFields) {
    cov_11cyncpti5().f[3]++;
    cov_11cyncpti5().s[12]++;
    return (cov_11cyncpti5().b[9][0]++, fieldNeedCheck) && (cov_11cyncpti5().b[9][1]++, fieldNeedCheck.length > 0) && (cov_11cyncpti5().b[9][2]++, countTotalArrayLength(otherFields) === 0);
  };
  // Build array that just contain filter field from object selectedOptions
  cov_11cyncpti5().s[13]++;
  var buildOptionsArray = function buildOptionsArray(options) {
    cov_11cyncpti5().f[4]++;
    var result = (cov_11cyncpti5().s[14]++, []);
    var fieldNames = (cov_11cyncpti5().s[15]++, (0, _values.default)(filterFieldName));
    cov_11cyncpti5().s[16]++;
    (0, _keys.default)(options).forEach(function (key) {
      cov_11cyncpti5().f[5]++;
      cov_11cyncpti5().s[17]++;
      if (fieldNames.indexOf(key) !== -1) {
        cov_11cyncpti5().b[10][0]++;
        cov_11cyncpti5().s[18]++;
        result.push(options[key]);
      } else {
        cov_11cyncpti5().b[10][1]++;
      }
    });
    cov_11cyncpti5().s[19]++;
    return result;
  };
  /*
  * Check if the filter should be handle or not
  * Case 1: this filter is just selected (change) => avoid it filter itself
  * Case 2: this filter is only filter that is selected => avoid that filter (the only filter left) just have selected option of itself
  */
  cov_11cyncpti5().s[20]++;
  var isNotHandleThisFilter = function isNotHandleThisFilter(fieldName, options) {
    cov_11cyncpti5().f[6]++;
    var fieldNeedCheck = (cov_11cyncpti5().s[21]++, options[fieldName]);
    var fields = (cov_11cyncpti5().s[22]++, buildOptionsArray(options));
    var otherFieldLeft = (cov_11cyncpti5().s[23]++, fields.filter(function (field) {
      cov_11cyncpti5().f[7]++;
      cov_11cyncpti5().s[24]++;
      return field !== fieldNeedCheck;
    }));
    cov_11cyncpti5().s[25]++;
    return (cov_11cyncpti5().b[11][0]++, filterFieldsChanges.includes(fieldName)) || (cov_11cyncpti5().b[11][1]++, isJustOnlyThisFieldSelected(fieldNeedCheck, otherFieldLeft));
  };
  // Getting all the matches taking into account the Sites and Teams selected
  var resultMatches = (cov_11cyncpti5().s[26]++, [].concat((cov_11cyncpti5().b[12][0]++, selectedOptions.matchNames) || (cov_11cyncpti5().b[12][1]++, [])));
  var resultTeams = (cov_11cyncpti5().s[27]++, [].concat((cov_11cyncpti5().b[13][0]++, selectedOptions.teamIds) || (cov_11cyncpti5().b[13][1]++, [])));
  var resultSites = (cov_11cyncpti5().s[28]++, [].concat((cov_11cyncpti5().b[14][0]++, selectedOptions.siteIds) || (cov_11cyncpti5().b[14][1]++, [])));
  cov_11cyncpti5().s[29]++;
  allOptions.hospitalitySessionData.forEach(function (hospitalityData) {
    cov_11cyncpti5().f[8]++;
    cov_11cyncpti5().s[30]++;
    // MATCH NAME filter
    if ((cov_11cyncpti5().b[16][0]++, selectedOptions.matchNames) && (cov_11cyncpti5().b[16][1]++, resultMatches.indexOf(hospitalityData.value) !== -1)) {
      cov_11cyncpti5().b[15][0]++;
      cov_11cyncpti5().s[31]++;
      if ((cov_11cyncpti5().b[18][0]++, hospitalityData.hostTeam) && (cov_11cyncpti5().b[18][1]++, hospitalityData.opposingTeam)) {
        cov_11cyncpti5().b[17][0]++;
        cov_11cyncpti5().s[32]++;
        resultTeams.push(hospitalityData.hostTeam.id);
        cov_11cyncpti5().s[33]++;
        resultTeams.push(hospitalityData.opposingTeam.id);
      } else {
        cov_11cyncpti5().b[17][1]++;
      }
      cov_11cyncpti5().s[34]++;
      if (hospitalityData.site) {
        cov_11cyncpti5().b[19][0]++;
        cov_11cyncpti5().s[35]++;
        resultSites.push(hospitalityData.site.id);
      } else {
        cov_11cyncpti5().b[19][1]++;
      }
    } else {
      cov_11cyncpti5().b[15][1]++;
    }
    // SITE filter
    // If the match is not included but has Sites' information, we check in the list of sites selected
    cov_11cyncpti5().s[36]++;
    if ((cov_11cyncpti5().b[21][0]++, selectedOptions.siteIds) && (cov_11cyncpti5().b[21][1]++, hospitalityData.site) && (cov_11cyncpti5().b[21][2]++, selectedOptions.siteIds.indexOf(hospitalityData.site.id) !== -1)) {
      cov_11cyncpti5().b[20][0]++;
      cov_11cyncpti5().s[37]++;
      // Match found, so we insert it only if there is not selected teams or there are team selected in that site
      if ((cov_11cyncpti5().b[23][0]++, !selectedOptions.teamIds) || (cov_11cyncpti5().b[23][1]++, selectedOptions.teamIds) && (cov_11cyncpti5().b[23][2]++, hospitalityData.hostTeam) && (cov_11cyncpti5().b[23][3]++, hospitalityData.opposingTeam) && ((cov_11cyncpti5().b[23][4]++, selectedOptions.teamIds.indexOf(hospitalityData.hostTeam.id) !== -1) || (cov_11cyncpti5().b[23][5]++, selectedOptions.teamIds.indexOf(hospitalityData.opposingTeam.id) !== -1))) {
        cov_11cyncpti5().b[22][0]++;
        cov_11cyncpti5().s[38]++;
        resultMatches.push(hospitalityData.value);
      } else {
        cov_11cyncpti5().b[22][1]++;
      }
      // also the teams involved
      cov_11cyncpti5().s[39]++;
      if ((cov_11cyncpti5().b[25][0]++, hospitalityData.hostTeam) && (cov_11cyncpti5().b[25][1]++, resultTeams.indexOf(hospitalityData.hostTeam.id) === -1)) {
        cov_11cyncpti5().b[24][0]++;
        cov_11cyncpti5().s[40]++;
        resultTeams.push(hospitalityData.hostTeam.id);
      } else {
        cov_11cyncpti5().b[24][1]++;
      }
      cov_11cyncpti5().s[41]++;
      if ((cov_11cyncpti5().b[27][0]++, hospitalityData.opposingTeam) && (cov_11cyncpti5().b[27][1]++, resultTeams.indexOf(hospitalityData.opposingTeam.id) === -1)) {
        cov_11cyncpti5().b[26][0]++;
        cov_11cyncpti5().s[42]++;
        resultTeams.push(hospitalityData.opposingTeam.id);
      } else {
        cov_11cyncpti5().b[26][1]++;
      }
    } else {
      cov_11cyncpti5().b[20][1]++;
    }
    // TEAM filter
    // If the match is not included but has teams' information, we check in the list of teams selected
    cov_11cyncpti5().s[43]++;
    if ((cov_11cyncpti5().b[29][0]++, selectedOptions.teamIds) && (cov_11cyncpti5().b[29][1]++, hospitalityData.hostTeam) && (cov_11cyncpti5().b[29][2]++, hospitalityData.opposingTeam)) {
      cov_11cyncpti5().b[28][0]++;
      cov_11cyncpti5().s[44]++;
      if ((cov_11cyncpti5().b[31][0]++, selectedOptions.teamIds.indexOf(hospitalityData.hostTeam.id) !== -1) || (cov_11cyncpti5().b[31][1]++, selectedOptions.teamIds.indexOf(hospitalityData.opposingTeam.id) !== -1)) {
        cov_11cyncpti5().b[30][0]++;
        cov_11cyncpti5().s[45]++;
        // Match found, we check dependent filters to include it
        if ((cov_11cyncpti5().b[33][0]++, !selectedOptions.siteIds) || (cov_11cyncpti5().b[33][1]++, selectedOptions.siteIds) && (cov_11cyncpti5().b[33][2]++, hospitalityData.site) && (cov_11cyncpti5().b[33][3]++, selectedOptions.siteIds.indexOf(hospitalityData.site.id) !== -1)) {
          cov_11cyncpti5().b[32][0]++;
          cov_11cyncpti5().s[46]++;
          resultMatches.push(hospitalityData.value);
        } else {
          cov_11cyncpti5().b[32][1]++;
        }
        // also the site related
        cov_11cyncpti5().s[47]++;
        if ((cov_11cyncpti5().b[35][0]++, hospitalityData.site) && (cov_11cyncpti5().b[35][1]++, hospitalityData.site.id) && (cov_11cyncpti5().b[35][2]++, resultSites.indexOf(hospitalityData.site.id) === -1)) {
          cov_11cyncpti5().b[34][0]++;
          cov_11cyncpti5().s[48]++;
          resultSites.push(hospitalityData.site.id);
        } else {
          cov_11cyncpti5().b[34][1]++;
        }
      } else {
        cov_11cyncpti5().b[30][1]++;
      }
    } else {
      cov_11cyncpti5().b[28][1]++;
    }
  });

  // After check all filter, check each filter should be update or keep current options
  cov_11cyncpti5().s[49]++;
  resultOptions.hospitalitySessionData = isNotHandleThisFilter(filterFieldName[_filter.FilterField.MATCH_NAME], selectedOptions) ? (cov_11cyncpti5().b[36][0]++, currentOptions.hospitalitySessionData) : (cov_11cyncpti5().b[36][1]++, allOptions.hospitalitySessionData.filter(function (match) {
    cov_11cyncpti5().f[9]++;
    cov_11cyncpti5().s[50]++;
    return resultMatches.indexOf(match.value) !== -1;
  }));
  cov_11cyncpti5().s[51]++;
  resultOptions.siteData = isNotHandleThisFilter(filterFieldName[_filter.FilterField.SITE], selectedOptions) ? (cov_11cyncpti5().b[37][0]++, currentOptions.siteData) : (cov_11cyncpti5().b[37][1]++, allOptions.siteData.filter(function (site) {
    cov_11cyncpti5().f[10]++;
    cov_11cyncpti5().s[52]++;
    return resultSites.indexOf(site.value) !== -1;
  }));
  cov_11cyncpti5().s[53]++;
  resultOptions.teamData = isNotHandleThisFilter(filterFieldName[_filter.FilterField.TEAM], selectedOptions) ? (cov_11cyncpti5().b[38][0]++, currentOptions.teamData) : (cov_11cyncpti5().b[38][1]++, allOptions.teamData.filter(function (team) {
    cov_11cyncpti5().f[11]++;
    cov_11cyncpti5().s[54]++;
    return resultTeams.indexOf(team.value) !== -1;
  }));
  cov_11cyncpti5().s[55]++;
  return resultOptions;
}
function findFieldUpdate(oldCriteria, newCriteria) {
  cov_11cyncpti5().f[12]++;
  var filterFieldChange = (cov_11cyncpti5().s[56]++, []);
  cov_11cyncpti5().s[57]++;
  (0, _keys.default)(newCriteria).forEach(function (key) {
    cov_11cyncpti5().f[13]++;
    cov_11cyncpti5().s[58]++;
    if (newCriteria[key] !== oldCriteria[key]) {
      cov_11cyncpti5().b[39][0]++;
      cov_11cyncpti5().s[59]++;
      filterFieldChange.push(key);
    } else {
      cov_11cyncpti5().b[39][1]++;
    }
  });
  cov_11cyncpti5().s[60]++;
  return filterFieldChange;
}
cov_11cyncpti5().s[61]++;
var getFilterBarActionWrapperColumnCss = exports.getFilterBarActionWrapperColumnCss = function getFilterBarActionWrapperColumnCss() {
  var cols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_11cyncpti5().b[40][0]++, 1);
  cov_11cyncpti5().f[14]++;
  cov_11cyncpti5().s[62]++;
  return (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    ", ";\n  "])), function (_ref2) {
    var children = _ref2.children;
    cov_11cyncpti5().f[15]++;
    var totalFilters = (cov_11cyncpti5().s[63]++, _react.default.Children.toArray(children).filter(Boolean).length);
    var totalCols = (cov_11cyncpti5().s[64]++, Math.max(1, cols));
    var remainder = (cov_11cyncpti5().s[65]++, totalFilters % totalCols);
    var startCol = (cov_11cyncpti5().s[66]++, (cov_11cyncpti5().b[41][0]++, remainder) || (cov_11cyncpti5().b[41][1]++, totalCols)); // If remainder is 0 its mean filters fit the cols so set it as last col
    var colSpan = (cov_11cyncpti5().s[67]++, totalCols + 1);
    cov_11cyncpti5().s[68]++;
    return (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n        grid-column: ", " / ", ";\n      "])), startCol, colSpan);
  });
};